import React from "react";
import SEO from "@/components/SEO";
import LocationTemplate from "@/components/LocationTemplate";

const CoburgNorthPage = () => <LocationTemplate suburbName="Coburg North" suburbSlug="coburg-north" />;

export default CoburgNorthPage;
